class HeaderSearchToggler extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => {

      const detailsModal = this.closest('header').querySelector('details-modal');
      if (detailsModal && detailsModal.summaryToggle) {
        console.log('detailsModal', detailsModal);
        detailsModal.querySelector('details')?.setAttribute('open', true);
        // detailsModal.summaryToggle.click();
        // debugger;
      } else {
        console.error('details-modal or its summaryToggle element not found.');
      }
    });
    
  }
}
customElements.define('header-search-toggler', HeaderSearchToggler);
